export enum InventoryLoaderId {
  CurrentLocations = "InventoryCurrentLocations",
  DetailPage = "InventoryDetailPage",
  FastTagsLinkModalButton = "FastTagsLinkModalButton",
}
